import { GOOGLE_MAPS_DECKGL_MARKERS } from '@rsos/capstone/src/constants/capabilities';
import { useFlag } from '@rsos/flags';
import useHasCapability from './useHasCapability';

/**
 * Custom hook that returns whether the Google Maps feature flag is enabled and
 * google_maps_deckgl_markers capability is enabled.
 */
const useIsGoogleMapsFeatureFlagEnhanced = () => {
  const hasGoogleMapsDeckglMarkersCapability = useHasCapability(
    GOOGLE_MAPS_DECKGL_MARKERS,
  );
  return (
    useFlag('google_maps_updates') &&
    hasGoogleMapsDeckglMarkersCapability?.hasCapability
  );
};

export default useIsGoogleMapsFeatureFlagEnhanced;
